<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";
import { useQuizMatchesStore } from "@/stores/storeQuizMatches";
import { useGameHistory } from "@/composables/useGameHistory";
import { useModals } from "@/composables/useModals";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { Scrollbar } from "swiper/modules";
import SliderScrollBar from "@/components/blocks/slider/SliderScrollBar.vue";
import SliderSlideUserPrize from "@/components/blocks/slider/SliderSlideUserPrize.vue";
import ProfileEmpty from "@/components/profile/ProfileEmpty.vue";
import QuizSlideTimer from "@/components/quize/QuizSlideTimer.vue";
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";

const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();
const storeQuizMatches = useQuizMatchesStore();
const { openModal } = useModals();
const { remainingTime, initTimer } = useGameHistory();

const isMobile = computed(() => storeSettings.widthWindow <= 1024);
const filteredListUserPrizes = computed(() => {
	return storeRequests.listUserPrizes.filter(item => item.prize.type !== "ticket_for_weekly" && item.prize.type !== "ticket_for_grand");
	
});
// ticket_for_grand ticket_for_weekly
const swiperBreakpoints = {
	320: {
		slidesPerView: 2.1,
		spaceBetween: 10,
	},
	376: {
		slidesPerView: 2.1,
		spaceBetween: 17,
	},
	481: {
		slidesPerView: 2.3,
		spaceBetween: 20,
	},
	577: {
		slidesPerView: 3,
		spaceBetween: 20,
	},
	769: {
		slidesPerView: 3.5,
		spaceBetween: 20,
	},
	993: {
		slidesPerView: 3,
		spaceBetween: 20,
	},
	1201: {
		slidesPerView: 5,
		spaceBetween: 28,
	},
};     

onMounted(async () => {
	await initTimer();
});
</script>
<template>
	<div class="user-prizes">
		<h2 class="user-prizes__title profile-title">Мои призы</h2> 
		<div class="user-prizes__slider" v-if="filteredListUserPrizes?.length || storeQuizMatches.isShowTimer">
			<SliderScrollBar class="user-prizes__scrollbar" />
			<Swiper
				:modules="[Scrollbar]"
				:observer="true"
				:observeParents="true"
				:observeSlideChildren="true"
				:resizeObserver="true"
				:scrollbar="{
					el: '.scrollbar',
					draggable: true,
				}"
				:breakpoints="swiperBreakpoints"
				class="user-prizes__swiper"
			>
				<SwiperSlide v-if="!storeQuizMatches.isGameMatchesSession" :class="['prizes-slide --prize-slide']">
					<button class="slide__info" type="button" @click="openModal('modalUserPrizeMatches', { size: 'w704' })">
						<svg width="32" height="32"><use xlink:href="#info"></use></svg>
					</button>
					<QuizSlideTimer class="--prize-slide" :time="remainingTime" />
					<p class="prizes-slide__title">Подарок за игру<br> «3 в ряд»</p>
					<BaseButtonUploadReceipt type-btn="upload_check_3_in_a_row_lk" v-if="!storeSettings.isTelegramPage" class="prizes-slide__btn --small">Загрузить чек</BaseButtonUploadReceipt>
				</SwiperSlide>
				<SwiperSlide :class="['prizes-slide']" v-for="prize in filteredListUserPrizes" :key="prize.id">
					<SliderSlideUserPrize :prize :is-mobile="isMobile" />
				</SwiperSlide>
			</Swiper>
		</div>
		<ProfileEmpty :active-btn="false" v-else>Призов пока что нет.</ProfileEmpty>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.user-prizes {
	&__title {
		margin-bottom: 37px;
	}

	&__slider {
	}

	&__scrollbar {
		margin-bottom: 37px;
	}

	&__swiper {
		// overflow: unset;
		@media (max-width: vars.$l) {
			padding-right: var(--padding-container);
			margin-right: calc(var(--padding-container) * -1);
		}
	}
}
.prizes-slide  {
	&.--prize-slide {
		display: flex;
		align-items: start;
		flex-direction: column;
		justify-content: space-between;
		gap: 2rem;
		height: auto;
		.prizes-slide  {

			&__title {
				font-weight: 500;
				font-size: 2rem;
				line-height: 120%;
				padding: 0 1.2rem 0.5rem;
				@media (max-width: vars.$x480) {
					font-size: 1.4rem;
					padding: 0 0.8rem;
				}
			}
			&__btn {
				width: 100%;
			}	
		}
	}
}
.slide__info {
		position: absolute;
		top: 1.5rem;
		right: 1.5rem;
		width: 3.2rem;
		height: 3.2rem;
		cursor: pointer;
		background: transparent;
		border: none;
		padding: 0;
		transition: opacity var(--transition);
		z-index: 1;
		@media (hover: hover) {
			&:hover {
				opacity: 0.7;
			}
		}

		@media (max-width: vars.$x480) {
			top: 1rem;
			right: 1rem;
			width: 2rem;
			height: 2rem;
		}

		svg {
			width: 100%;
			height: 100%;
			stroke: transparent;
		}
	}
</style>
